import axiosInstance from 'src/common/axiosInstance';

const conversationService = {

    index(phoneNumberId, params = {}) {

        return axiosInstance.get(
            `/phone-numbers/${phoneNumberId}/conversations`,
            {
                params,
            }
        );

    },

    show(phoneNumberId, conversationId) {

        return axiosInstance.get(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}`
        );

    },

    create(phoneNumberId, data) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations`,
            data
        );

    },

    update(phoneNumberId, conversationId, data) {

        return axiosInstance.put(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}`,
            data
        );

    },

    destroy(phoneNumberId, conversationId) {

        return axiosInstance.delete(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}`
        );

    },

    assign(phoneNumberId, conversationId, data) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/assign`,
            data
        );

    },

    unassign(phoneNumberId, conversationId) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/unassign`
        );

    },

    archive(phoneNumberId, conversationId) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/archive`
        );

    },

    unarchive(phoneNumberId, conversationId) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/unarchive`
        );

    },

    close(phoneNumberId, conversationId) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/close`
        );

    },

    reopen(phoneNumberId, conversationId) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/reopen`
        );

    },

    markAsRead(phoneNumberId, conversationId) {

        return axiosInstance.post(
            `/phone-numbers/${phoneNumberId}/conversations/${conversationId}/mark-as-read`
        );

    },

};

export default conversationService;